import styled, { keyframes, css } from 'styled-components';

export const Wrapper = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 100vw;
  z-index: 1000;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition-duration: 0.5s;
`;

const slideUp = keyframes`
  from {
    top: 50%;
    transform: scale(1) translateY(-50%);
  }
  to {
    top: 5%;
    transform: scale(0.5) translateY(-50%);
  }
`;

export const AnimatedImage = styled.img<{ animate: boolean }>`
  z-index: 1010;
  width: 327px;
  //max-width: 60%;
  top: 50%;
  transform: translateY(-50%);
  transform-origin: top;
  object-fit: contain;
  ${({ animate }) =>
    animate &&
    css`
      animation: ${slideUp} 1s ease forwards;
    `}
  @media (max-width: 768px) {
    width: 60%;
  }
`;
